(function () {
    'use strict';

    angular
        .module('app')
        /* @ngInject */
        .constant('WEB_FORM_ADMIN', function (modal) {
            var resolve = "$resolve.";
            if (modal) {
                resolve = "ctrl.resolve."
            }
            return {
                component: '<web-form-admin ' +
                'item="' + resolve + 'item" ' +
                'previous-params="' + resolve + 'previousParams"' +
                'permisos-categoria="' + resolve + 'permisosCategoria"' +
                'categorias="' + resolve + 'categorias"' +
                '></web-form-admin>',
                resolve: {
                    /* @ngInject */
                    item: function (Web) {
                        return new Web();
                    },
                    /* @ngInject */
                    permisosCategoria: function (COMPONENTES) {
                        return COMPONENTES.webs.categoriasAdmin;
                    },
                    /* @ngInject */
                    categorias: function (CategoriaWeb) {
                        return CategoriaWeb.query({sortProperty: 'nombre'}).$promise.then(function (data) {
                            return data.content;
                        });
                    }
                }
            }
        });
})();
